<template>
  <v-autocomplete
    :value="value"
    :items="list"
    :loading="isLoading"
    type="text"
    item-text="name"
    item-value="code"
    return-object
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template v-slot:label>
      <span
        v-if="required"
        class="red--text"
      >
        <strong>* </strong>
      </span>
      {{ label }}
    </template>
  </v-autocomplete>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

export default {
  components: {},
  props: {
    value: {
      type: String,
    },
    autoSelectFirst: {
      type: Boolean,
      default: false,
      required: false,
    },
    label: {
      type: String,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    isLoading: false,
  }),
  computed: {
    ...mapState('vsl/commodity', { list: 'commodityList' }),
  },
  async created() {
    try {
      this.isLoading = true;
      await this.fetchList();
      if (!this.value && this.autoSelectFirst && this.required) {
        this.$emit('change', this.list[0]);
      }
    } finally {
      this.isLoading = false;
    }
  },
  watch: {},
  methods: {
    ...mapActions('vsl/commodity', { fetchList: 'fetchCommodityList' }),
    onChange(value) {
      return this.$emit('change', value);
    },
  },
};
</script>

<style></style>
